import React from 'react';
import {FormattedMessage} from 'react-intl';
import {constants} from '@neosvoc/nv-platform-core-common';
import messages from '../../../res/translations/messages';

const CLOUD_EVENT_KEYS_BY_VALUE = Object.entries(constants.CLOUD_EVENTS)
    .reduce((acc, [key, value]) => ({...acc, [value]: key}), {});

export const getCloudEventMessage = (event) => {
    const key = CLOUD_EVENT_KEYS_BY_VALUE[event];
    return messages.cloudEvents[key] || {id: event, defaultMessage: event};
};

const CloudEventText = ({event}) => <FormattedMessage {...getCloudEventMessage(event)} />;

export default CloudEventText;
